import {fsa, fsaPayload, fsaError} from './helpers'

export const GET_NEAREST_SHOWROOMS = 'nearestShowrooms/get nearest showrooms'
export const getNearestShowrooms = fsa(GET_NEAREST_SHOWROOMS)

export const GET_NEAREST_SHOWROOMS_PENDING = 'nearestShowrooms/get nearest showrooms pending'
export const getNearestShowroomsPending = fsa(GET_NEAREST_SHOWROOMS_PENDING)

export const GET_NEAREST_SHOWROOMS_SUCCESS = 'nearestShowrooms/get nearest showrooms success'
export const getNearestShowroomsSuccess = fsaPayload(GET_NEAREST_SHOWROOMS_SUCCESS)

export const GET_NEAREST_SHOWROOMS_FAILURE = 'nearestShowrooms/get nearest showrooms failure'
export const getNearestShowroomsFailure = fsaError(GET_NEAREST_SHOWROOMS_FAILURE)

export const SHOW_NEAREST_SHOWROOM_BANNER = 'nearestShowrooms/show nearest showroom banner'
export const showNearestShowroomBanner = fsa(SHOW_NEAREST_SHOWROOM_BANNER)

export const HIDE_NEAREST_SHOWROOM_BANNER = 'nearestShowrooms/hide nearest showroom banner'
export const hideNearestShowroomBanner = fsa(HIDE_NEAREST_SHOWROOM_BANNER)
